import { render, staticRenderFns } from "./SiderMenuItems.vue?vue&type=template&id=7fc1aa92&scoped=true&"
import script from "./SiderMenuItems.vue?vue&type=script&lang=js&"
export * from "./SiderMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc1aa92",
  null
  
)

export default component.exports